import { render, staticRenderFns } from "./SuccessCard.vue?vue&type=template&id=55aaea73"
import script from "./SuccessCard.vue?vue&type=script&lang=js"
export * from "./SuccessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports